import lodash from 'lodash';
const { merge } = lodash;
const createAllWalletAccountsEver = () => {
    let tailChannel;
    const grantChannelAccess = ({ tail }) => {
        tailChannel = tail;
    };
    return {
        grantChannelAccess,
        get: async () => {
            if (!tailChannel)
                throw new Error('channel access not granted');
            const history = await tailChannel();
            const entries = history.map(({ walletAccounts }) => walletAccounts);
            return merge({}, ...entries);
        },
    };
};
const allWalletAccountsEverDefinition = {
    id: 'allWalletAccountsEver',
    type: 'module',
    factory: createAllWalletAccountsEver,
    dependencies: [],
};
export default allWalletAccountsEverDefinition;
